<template>
    <poreturn-check
      :sna-id="snaId"
      :data.sync="checkDataInfo"
    >
      <template #footer>
        <check-module :title="`审批`">
          <check-handle-module
            :check-from-data="checkFromData"
            :pass-dialog-txt="`审批通过后退货流程将流转到下一阶段`"
            @submitCheck="submitCheck"
          ></check-handle-module>
        </check-module>
      </template>
    </poreturn-check>
</template>

<script>
import PoreturnCheck from '@/views/workbench/workCheckManage/poreturnCheck/poreturnCheck'
import checkMixin from '@/mixin/checkMixin'
import checkApi from '@/api/workbench/check'
export default {
  name: 'poreturnCheckView',
  mixins: [checkMixin],
  components: { PoreturnCheck },
  data() {
    return {
      checkDetailName: 'poreturncheckdetail'
    }
  },
  methods: {
    submitCheck (form) {
      const params = this.formatCheckParams(form)
      checkApi.submitPoreturnCheck(params).then(res => {
        this.goCheckDetail(res)
      })
    }
  }
}
</script>

<style scoped>

</style>
